export default {"src":"/oferta/_next/static/media/instagram.192f2d2f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};